import axios from 'axios'
import { Toast } from 'vant'
import router from '@/router'
// 为axios配置公共路径

// ajax请求统一增加请求头
axios.interceptors.request.use(config => {
  config.headers.common = {
  }
  const token = localStorage.getItem('token')
  // 如果 Token 存在，则添加到请求头
  if (token) {
    //config.headers.Authorization = `Bearer ${token}`
    config.headers.satoken=`${token}`
  }
  
  config.timeout = 6*300000
  if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
    config.data = {
      ...config.data,
      // protocol,
      _t: Date.parse(new Date()) / 1000
    }
  } else if (config.method === 'get') {
    config.params = {
      _t: Date.parse(new Date()) / 1000,
      // protocol,
      ...config.params
    }
  }
  //console.log(config,'config')
  return config
}, () => {
  return null
})

// 拦截响应response，并做一些错误处理
axios.interceptors.response.use((response) => {
  const data = response.data
  if(response.data.code==-1){
    Toast(response.data.msg)
   
    let url = '/qzlx2026/login'
    if(window.location.pathname.indexOf('/qzlx2026') > -1){
      url = '/qzlx2026/login'
    }else if(window.location.pathname.indexOf('/qzlx2025') > -1){
      url = '/qzlx2025/login'
    }
    
    setTimeout(() => {
      router.replace({
        path: url
      })
    }, 3000)
  }
  if(response.data.code!==0&&response.data.code!==-1){
    Toast(response.data.msg)
  }
  // if (response.data.code !=0) {
    
  //   // Toast({
  //   //   message: response.data.msg
  //   // })
  //   return Promise.reject(new Error(data.msg))
  // }
  return data
}, (err) => {
  console.log(err,'err')
  // 这里是返回状态码不为200时候的错误处理
  if (err.toString().indexOf('timeout') !== -1) {
    console.log(err)
  }
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误'
        break

      case 401:
        err.message = '未授权，请登录'
        break

      case 403:
        err.message = '拒绝访问'
        break

      case 404:
        err.message = `请求地址出错: ${err.response.config.url}`
        break
      case 405:
        err.message = '请求地址出错:'
        break
      case 408:
        err.message = '请求超时'
        break

      case 500:
        err.message = '服务器开个小差，请稍后再试'
        break

      case 501:
        err.message = '服务器开个小差，请稍后再试'
        break

      case 502:
        err.message = '服务器开个小差，请稍后再试'
        break

      case 503:
        err.message = '服务器开个小差，请稍后再试'
        break

      case 504:
        err.message = '服务器开个小差，请稍后再试'
        break

      case 505:
        err.message = 'HTTP版本不受支持'
        break
      default:
    }
    // if (err.response.data.msg) {
    //   err.message = err.response.data.msg
    // }

    Toast(err.message)
  }

  return Promise.reject(err)
})

export default axios
